import React from "react";
import {
  Box,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const PASOS = [
  { key: "empresa", label: "Empresa" },
  { key: "comprobantes", label: "Comprobantes" },
  { key: "medio", label: "Medio de pago" },
  { key: "confirmacion", label: "Confirmación" },
];

const estadoPaso = (index, activeStep) => {
  if (index < activeStep) return { texto: "Completado", color: "success.main" };
  if (index === activeStep) return { texto: "En curso", color: "primary.main" };
  return { texto: "Pendiente", color: "text.secondary" };
};

const ICON_SIZE = 22;

const OrdenPagoStepper = ({ activeStep }) => (
  <Box
    sx={{
      mb: 2,
      px: 2,
      py: 0.75,
      backgroundColor: "#fff",
      borderRadius: 1,
      border: "1px solid #e8e8e8",
    }}
  >
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      sx={{
        py: 0,
        "& .MuiStepConnector-alternativeLabel": {
          top: ICON_SIZE / 2,
        },
        "& .MuiStepLabel-root": {
          py: 0,
        },
        "& .MuiStepLabel-labelContainer": {
          mt: 0.25,
        },
      }}
    >
      {PASOS.map((paso, index) => {
        const { texto, color } = estadoPaso(index, activeStep);
        const completado = index < activeStep;

        return (
          <Step key={paso.key} completed={completado}>
            <StepLabel
              StepIconComponent={() =>
                completado ? (
                  <CheckCircleIcon color="primary" sx={{ fontSize: ICON_SIZE + 2 }} />
                ) : (
                  <Box
                    sx={{
                      width: ICON_SIZE,
                      height: ICON_SIZE,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 600,
                      fontSize: 12,
                      border: "2px solid",
                      borderColor:
                        index === activeStep ? "primary.main" : "#bdbdbd",
                      color: index === activeStep ? "primary.main" : "#9e9e9e",
                      backgroundColor: "#fff",
                    }}
                  >
                    {index + 1}
                  </Box>
                )
              }
            >
              <Typography variant="body2" fontWeight={600} lineHeight={1.2}>
                {paso.label}
              </Typography>
              <Typography variant="caption" sx={{ color, lineHeight: 1.1, display: "block" }}>
                {texto}
              </Typography>
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  </Box>
);

export default OrdenPagoStepper;
